// This is taken from PHP side see constants.inc.php
export var ResourceType;
(function(ResourceType) {
    ResourceType[ResourceType["DEVIATION"] = 1] = "DEVIATION";
    ResourceType[ResourceType["NEWS"] = 2] = "NEWS";
    ResourceType[ResourceType["SOFTWARE"] = 3] = "SOFTWARE";
    ResourceType[ResourceType["USER"] = 4] = "USER";
    ResourceType[ResourceType["JOURNAL"] = 5] = "JOURNAL";
    ResourceType[ResourceType["POLL"] = 6] = "POLL";
    ResourceType[ResourceType["EVENT"] = 7] = "EVENT";
    ResourceType[ResourceType["HELP"] = 9] = "HELP";
    ResourceType[ResourceType["PROJECT_MANAGER"] = 10] = "PROJECT_MANAGER";
    ResourceType[ResourceType["REPORT"] = 11] = "REPORT";
    ResourceType[ResourceType["CALENDAR"] = 12] = "CALENDAR";
    ResourceType[ResourceType["PRINTADMIN"] = 13] = "PRINTADMIN";
    ResourceType[ResourceType["POLL_BLOG"] = 14] = "POLL_BLOG";
    ResourceType[ResourceType["PROJECT_MAIN"] = 15] = "PROJECT_MAIN";
    ResourceType[ResourceType["PROJECT_SUMMIT"] = 16] = "PROJECT_SUMMIT";
    ResourceType[ResourceType["SUMMIT_MANAGER"] = 17] = "SUMMIT_MANAGER";
    ResourceType[ResourceType["FORUM"] = 18] = "FORUM";
    ResourceType[ResourceType["USERFORUM"] = 19] = "USERFORUM";
    ResourceType[ResourceType["GALLERY"] = 20] = "GALLERY";
    ResourceType[ResourceType["COLLECTION"] = 21] = "COLLECTION";
    ResourceType[ResourceType["CHECKOUT"] = 22] = "CHECKOUT";
    ResourceType[ResourceType["COMMENT"] = 24] = "COMMENT";
    ResourceType[ResourceType["MESSAGEBOX"] = 25] = "MESSAGEBOX";
    ResourceType[ResourceType["NOTE"] = 26] = "NOTE";
    ResourceType[ResourceType["RAP"] = 27] = "RAP";
    ResourceType[ResourceType["HELP_NOTE"] = 28] = "HELP_NOTE";
    ResourceType[ResourceType["MODULE"] = 29] = "MODULE";
    ResourceType[ResourceType["CRITIQUE"] = 30] = "CRITIQUE";
    ResourceType[ResourceType["GROUP"] = 31] = "GROUP";
    ResourceType[ResourceType["SHOPITEM"] = 32] = "SHOPITEM";
    ResourceType[ResourceType["SKIN"] = 33] = "SKIN";
    ResourceType[ResourceType["PRINT"] = 34] = "PRINT";
    ResourceType[ResourceType["WORKFLOW"] = 35] = "WORKFLOW";
    ResourceType[ResourceType["GROUP_ROLE"] = 37] = "GROUP_ROLE";
    ResourceType[ResourceType["DEVMEET"] = 38] = "DEVMEET";
    ResourceType[ResourceType["THREADNOTE"] = 39] = "THREADNOTE";
    ResourceType[ResourceType["SHOP"] = 40] = "SHOP";
    ResourceType[ResourceType["MODULE_TICKETTRACKER"] = 44] = "MODULE_TICKETTRACKER";
    ResourceType[ResourceType["MODULE_CONVERSATION"] = 46] = "MODULE_CONVERSATION";
    ResourceType[ResourceType["MODULE_BULLETIN"] = 47] = "MODULE_BULLETIN";
    ResourceType[ResourceType["ORDER"] = 48] = "ORDER";
    ResourceType[ResourceType["POINTS_TRANSACTION"] = 50] = "POINTS_TRANSACTION";
    ResourceType[ResourceType["STACK_DEVWATCH"] = 51] = "STACK_DEVWATCH";
    ResourceType[ResourceType["STACK_COMMENTS"] = 52] = "STACK_COMMENTS";
    ResourceType[ResourceType["BADGE"] = 53] = "BADGE";
    ResourceType[ResourceType["STASH"] = 59] = "STASH";
    ResourceType[ResourceType["MODULE_ADMINSTATS"] = 60] = "MODULE_ADMINSTATS";
    ResourceType[ResourceType["USERPROFITS"] = 62] = "USERPROFITS";
    ResourceType[ResourceType["USER_RENAME_HISTORY"] = 63] = "USER_RENAME_HISTORY";
    ResourceType[ResourceType["COMMISSION"] = 66] = "COMMISSION";
    ResourceType[ResourceType["ORDERED_DEVIATION_FOLDER"] = 67] = "ORDERED_DEVIATION_FOLDER";
    ResourceType[ResourceType["STACK_MENTIONS"] = 68] = "STACK_MENTIONS";
    ResourceType[ResourceType["STATUS"] = 69] = "STATUS";
    ResourceType[ResourceType["TODAY"] = 70] = "TODAY";
    ResourceType[ResourceType["DISCOVERYTAG"] = 71] = "DISCOVERYTAG";
    ResourceType[ResourceType["DAILYDEVIATION"] = 72] = "DAILYDEVIATION";
    ResourceType[ResourceType["HOT_TOPIC"] = 75] = "HOT_TOPIC";
    ResourceType[ResourceType["BIRTHDAY"] = 76] = "BIRTHDAY";
    ResourceType[ResourceType["MODERATION_MESSAGE"] = 77] = "MODERATION_MESSAGE";
    ResourceType[ResourceType["TOPIC"] = 78] = "TOPIC";
    ResourceType[ResourceType["STATUS_DEVIATION"] = 81] = "STATUS_DEVIATION";
    ResourceType[ResourceType["TIER"] = 82] = "TIER";
})(ResourceType || (ResourceType = {}));

//# sourceMappingURL=resource.js.map